// extracted by mini-css-extract-plugin
export var quillEditor = "_m5-1";
export var variable = "_m5-0";